import { ProductRouteNotFound } from '@/shared/communication-product/product-route-not-found';

export default ProductRouteNotFound;
